/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import React from "react";

export default class Loader extends React.Component {
  render() {
    return (
      <div className="Loader-wrpper">
        <div className="mainLoader"></div>
      </div>
    );
  }
}
